/* eslint-disable react/forbid-prop-types */
import { API } from 'aws-amplify';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Fade } from '@mui/material';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Popover,
  Box,
  Spacer,
  Divider,
  TextField,
  // getVersion as getComponentsVersion,
} from '@eatclubapp/ec-component-library';
import { getVersion as getBookingsVersion } from '@eatclubapp/ec-bookings-library';
import { setLogoutAction } from '../../../data/actions/loginAction';
import { restaurantBySlug } from '../../../data/graphql/queries';
import { restaurantActivePropTypes } from '../../../data/models/Restaurant';
import { devLog } from '../../../utils';
import { generateAddressString, getAppVersion, getVersion, isEmpty } from '../../../utils/helpers';
import { SquareButton } from '../../Button/SquareButton';
import ProfileModal from '../../Profile/ProfileModal';
import useStyles from './NavigationStyles';
import LogoutIconSVG from '../../../assets/exit.svg';

const RestaurantSwitcher = ({
  restaurantActive,
  setLogout,
  isOpen,
  onClose,
  anchor,
  linkedVenues,
  isAdmin,
}) => {
  const classes = useStyles();
  const restaurant = restaurantActive?.restaurant;

  const [showProfile, setShowProfile] = useState(false);
  const [linkedRestaurants, setLinkedRestaurants] = useState([]);
  const [newRestaurantText, setNewRestaurantText] = useState('');

  // After signing in, switch to another venue if doing that
  const switchVenue = async (venueToSwitchTo) => {
    const params = new URLSearchParams(window.location.search);

    try {
      const response = await API.graphql(
        {
          query: restaurantBySlug,
          variables: {
            slug: venueToSwitchTo,
          },
          authMode: 'AMAZON_COGNITO_USER_POOLS',
        },
        {
          'app-version': getAppVersion(),
          'X-App-Environment': import.meta.env?.VITE_API_ENVIRONMENT,
        },
      );

      const restaurantId = response?.data?.restaurantBySlug?.objectId;
      if (restaurantId) {
        devLog('info', 'login', 'setting selected restaurant', restaurantId);
        sessionStorage.setItem('selectedRestaurant', restaurantId);
        localStorage.setItem(`lastUsedRestaurant`, restaurantId);
      }

      const paramsString = params.toString();

      window.location.href = `/${paramsString ? `?${paramsString}` : ''}`;
    } catch (error) {
      devLog('error', 'restaurants', error);
    }
  };

  const switchRestaurantThroughText = () => {
    switchVenue(newRestaurantText).then();
  };

  // Fetch the linked venues for name and address
  useEffect(() => {
    if (!isEmpty(linkedVenues) && restaurant.objectId) {
      Promise.all(
        linkedVenues.map(async (linkedVenue) => {
          try {
            const response = await API.graphql(
              {
                query: restaurantBySlug,
                variables: {
                  slug: linkedVenue.directory,
                },
                authMode: 'AMAZON_COGNITO_USER_POOLS',
              },
              {
                'app-version': getAppVersion(),
                'X-App-Environment': import.meta.env?.VITE_API_ENVIRONMENT,
              },
            );

            // devLog('success', 'restaurantSearchByName', response.data.restaurantBySlug);
            return response?.data?.restaurantBySlug;
          } catch (error) {
            devLog('error', 'restaurants', error);
          }

          return null;
        }),
      ).then((results) => {
        setLinkedRestaurants(
          results.filter((result) => result && result?.objectId !== restaurant.objectId),
        );
      });
    }
  }, [linkedVenues, restaurant.objectId]);

  const handleLogout = () => {
    setLogout(restaurantActive.restaurant.slug);
  };

  const handleCloseMenu = () => {
    setShowProfile(false);
    onClose(null);
  };

  const changeVenue = (newVenueId) => {
    handleCloseMenu();

    // localStorage.setItem('userId', newRestaurantId);
    devLog('info', 'restaurant', 'setting new selected restaurant');
    sessionStorage.setItem('selectedRestaurant', newVenueId);
    localStorage.setItem(`lastUsedRestaurant`, newVenueId);
    sessionStorage.removeItem('sessionFilter');
    // Reload so all data gets fetched again
    window.location.reload();
  };

  return (
    <Spacer style={{ position: 'relative' }}>
      <Popover
        isOpen={isOpen}
        onClose={() => handleCloseMenu()}
        anchorEl={anchor}
        style={{
          backgroundColor: '#00000070',
        }}
        innerStyle={{
          // These styles are to undo the default MUI, so we can have 2 divs above the background
          padding: 0,
          paddingTop: '10px',
          marginLeft: '-6px',
          backgroundColor: 'transparent',
          boxShadow: 'none',
          pointerEvents: 'none',
          marginTop: '10px', // offsets the popover top style property
          borderRadius: 'none',
        }}
        innerProps={{
          TransitionComponent: Fade,
          TransitionProps: { timeout: 0 },
        }}
      >
        <>
          <Box className={classes.accountMenuWrapper}>
            <Box className={classes.accountMenuContent}>
              {!isEmpty(restaurant) && (
                <Spacer gap='m' style={{ alignItems: 'flex-start', padding: '24px' }}>
                  <Box className={classes.logoContainer}>
                    {/* <LogoSVG style={{ flexShrink: 0, height: '29px', width: '29px' }} /> */}
                    {restaurant.name?.[0]}
                  </Box>
                  <Spacer direction='vertical' gap={12}>
                    <Spacer direction='vertical'>
                      <Box className={classes.restaurantName}>{restaurant.name}</Box>
                      <Box className={classes.restaurantAddress}>
                        {generateAddressString(
                          restaurant.address1,
                          restaurant.address2,
                          restaurant.city,
                          restaurant.state,
                        )}
                      </Box>
                    </Spacer>

                    <SquareButton
                      onClick={() => {
                        setShowProfile(true);
                      }}
                    >
                      {/* Update profile */}
                      View profile
                    </SquareButton>
                  </Spacer>
                </Spacer>
              )}

              <Divider />

              {/* Why do I bother? */}
              {/* {isAdmin && ( */}
              {/*  <> */}
              {/*    <Box className={classes.navigationLinks}> */}
              {/*      <Box className={classes.venueSelectorTitle}>Obee Staff venue switcher</Box> */}
              {/*      <Spacer> */}
              {/*        <TextField */}
              {/*          value={newRestaurantText} */}
              {/*          onChange={setNewRestaurantText} */}
              {/*          onEnter={switchRestaurantThroughText} */}
              {/*          placeholder='e.g. demoellav3' */}
              {/*        /> */}
              {/*        <SquareButton onClick={switchRestaurantThroughText}>Switch</SquareButton> */}
              {/*      </Spacer> */}
              {/*    </Box> */}
              {/*  </> */}
              {/* )} */}

              {!isEmpty(linkedRestaurants) && (
                <>
                  <Box className={classes.navigationLinks}>
                    <Box className={classes.venueSelectorTitle}>Change venue</Box>

                    {linkedRestaurants.map((linkedVenue) => (
                      <Box
                        key={linkedVenue.objectId}
                        onClick={() => changeVenue(linkedVenue.objectId)}
                      >
                        <Spacer gap={0} direction='vertical' className={classes.navigationLink}>
                          <Box className={classes.linkedVenueName}>{linkedVenue.name}</Box>
                          <Box className={classes.linkedVenueAddress}>
                            {generateAddressString(
                              linkedVenue.address1,
                              linkedVenue.address2,
                              linkedVenue.city,
                              linkedVenue.state,
                            )}
                          </Box>
                        </Spacer>
                      </Box>
                    ))}
                  </Box>

                  <Divider />
                </>
              )}

              <Box className={classes.bottomLink} onClick={handleLogout}>
                <Box className={classes.linkIcon}>
                  <LogoutIconSVG />
                </Box>
                <Box>Log out</Box>
              </Box>
            </Box>
          </Box>

          <Box style={{ position: 'fixed', bottom: '20px', right: '40px', color: '#CCCCCC' }}>
            App version {getVersion()}, {getBookingsVersion()}
          </Box>
        </>
      </Popover>

      <ProfileModal isOpen={showProfile} onClose={() => handleCloseMenu()} />
    </Spacer>
  );
};

RestaurantSwitcher.defaultProps = {
  anchor: null,
  linkedVenues: [],
  isAdmin: false,
};

RestaurantSwitcher.propTypes = {
  restaurantActive: restaurantActivePropTypes.isRequired,
  setLogout: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  anchor: PropTypes.shape({}),
  linkedVenues: PropTypes.arrayOf(PropTypes.shape({})),
  isAdmin: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  restaurantActive: state.restaurantActive,
  linkedVenues: state.restaurant.linkedVenues,
  isAdmin: state.user.isAdmin,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setLogout: setLogoutAction }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RestaurantSwitcher);
